import { apiClient } from './client';
import type { MeItemEntry } from '@/types/inventory';
import type { MeShipComponentEntry } from '@/types/shipComponent';

/** Coffre de progression non ouvert (cf PlayerRewardChestModel). */
export interface RewardChest {
  id: number;
  playerUniverseId: number;
  /** 'Level' (niveau) ou 'Military' (rang militaire). */
  chestType: 'Level' | 'Military' | 'Excavation';
  /** Palier atteint : n° de niveau, ou Order du rang. */
  tier: number;
  opened: boolean;
  grantedAt: string;
}

export interface RewardChestLootLine {
  label: string;
  rarity: number; // 0..3
  /** Code image (dossier /images/items/) pour la vignette. */
  imageCode?: string | null;
  /** Description (pour le tooltip au survol). */
  description?: string | null;
}

/** Une carte de butin unifiée (révélation à retourner). */
export interface RewardChestCard {
  kind: 'flouz' | 'resource' | 'item' | 'component';
  label: string;
  imageCode?: string | null;
  /** Dossier d'image : resources / items / components. */
  imageFolder: string;
  rarity: number;
  quantity: number;
  description?: string | null;
  /** OBJET : entrée d'inventaire riche → rendu via toDisplayItem (identique inventaire). */
  item?: MeItemEntry | null;
  /** COMPOSANT : entrée d'inventaire riche → rendu via shipComponentToDisplayItem. */
  component?: MeShipComponentEntry | null;
}

/** Butin révélé à l'ouverture (cf RewardChestOpenResultDto). */
export interface RewardChestOpenResult {
  chestId: number;
  chestType: 'Level' | 'Military' | 'Excavation';
  tier: number;
  flouz: number;
  resources: number;
  resourceCode?: string | null;
  items: RewardChestLootLine[];
  components: string[];
  /** Butin unifié en cartes (rendu + animation de révélation). */
  cards: RewardChestCard[];
}

/** Coffres NON ouverts du joueur (cumul). */
export async function fetchUnopenedChests(playerUniverseId: number): Promise<RewardChest[]> {
  const { data } = await apiClient.get<RewardChest[]>('/api/v1/RewardChest', {
    params: { playerUniverseId },
  });
  return data;
}

/** Ouvre un coffre et renvoie le butin révélé. */
export async function openRewardChest(
  chestId: number,
  playerUniverseId: number,
): Promise<RewardChestOpenResult> {
  const { data } = await apiClient.post<RewardChestOpenResult>(
    `/api/v1/RewardChest/${chestId}/open`,
    { playerUniverseId },
  );
  return data;
}
